module.exports = __webpack_public_path__ + "static/img/icons-arrow-up.09121605.svg";